export default class Faqs {
	constructor() {
		// Listen for click on the document
		document.addEventListener("click", function (event) {
			//Bail if our clicked element doesn't have the class
			var currentElement = event.target;

			if (
				!currentElement.classList.contains("faqs__item__question__link")
			)
				return;

			if (currentElement.classList.contains("active")) {
				currentElement.classList.remove("active");
			}

			// Get the target content
			var content = document.querySelector(event.target.hash);
			if (!content) return;

			// Prevent default link behavior
			event.preventDefault();

			// If the content is already expanded, collapse it and quit
			if (content.classList.contains("active")) {
				content.classList.remove("active");
				return;
			}

			// Get all open accordion content, loop through it, and close it
			var accordions = document.querySelectorAll(
				".faqs__item__answer.active"
			);
			for (var i = 0; i < accordions.length; i++) {
				accordions[i].classList.remove("active");
			}

			var questions = document.querySelectorAll(
				".faqs__item__question__link.active"
			);
			for (var i = 0; i < questions.length; i++) {
				questions[i].classList.remove("active");
			}

			// Toggle our content
			content.classList.toggle("active");
			currentElement.classList.add("active");
		});
	}
}
